import React, { useState } from 'react';
import CamposCantidadParticipantes from '../campos/CamposCantidadParticipantes.js';
import * as Campos from '../../constantes/Campos.js';
import CuadroEditable from '../../UI/CuadroEditable.js';
import usePatchURL from '../../../hooks/usePatchURL.js';

const CuadroEditableCantidadParticipantes = (props) => {
  const torneoOriginal = props.datosElegidos?.torneo;
  const [torneo, setTorneo] = useState(torneoOriginal);
  const [editar, setEditar] = useState(false);
  const { isGrabando, erroresPatch, patchData, resetErroresPatch } = usePatchURL();

  const onCampoChange = (campo, valor) => {
    if (campo === Campos.Torneo.CANTIDAD_PARTICIPANTES) {
      setTorneo({ ...torneo, cantidadParticipantes: valor });
    }
  };

  const datosGrabados = () => {
    setEditar(false);
    resetErroresPatch();
  };

  const botonEditarHandler = (event) => {
    if (editar) {
      setTorneo(torneoOriginal);
    }
    setEditar(!editar);
  };

  const botonGrabarHandler = async (event) => {
    event.preventDefault();

    if (!torneo.cantidadParticipantes || torneo.cantidadParticipantes < 2) {
      alert('La cantidad de participantes debe ser al menos 2');
      return;
    }

    if (torneo.cantidadParticipantes > 999) {
      alert('La cantidad de participantes no puede superar 999');
      return;
    }

    const dto = {
      cantidadParticipantes: torneo.cantidadParticipantes,
    };

    await patchData('torneos/' + torneo.id, dto, datosGrabados);
  };

  if (!torneoOriginal) {
    return null;
  }

  return (
    <CuadroEditable
      titulo="Cantidad de Participantes"
      editar={editar}
      error={erroresPatch}
      isGrabando={isGrabando}
      botonEditarHandler={botonEditarHandler}
      botonAceptarHandler={botonGrabarHandler}
      campos={
        <CamposCantidadParticipantes
          torneo={torneo}
          editar={editar}
          onCampoChange={onCampoChange}
        />
      }
    />
  );
};

export default CuadroEditableCantidadParticipantes;
